import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import InputField from "../inputField/InputField";
import Strings from "../../res/String";
import Model from "../model/Model";
import { useLocation, useNavigate } from "react-router-dom";
import PopUpModal from "../popupmodal/PopUpModal";
import logo from "../../assets/img/timber_logo.png";
import { useMutation } from "react-query";
import axios from "axios";
const EditUserForm = () => {
  const { control, handleSubmit, setValue, reset, watch } = useForm();
  const {state} = useLocation();
  console.log("state",state)
  const navigate = useNavigate();
 
  const [isPopupOpen, setPopupOpen] = useState(false);
  const togglePopup = () => {
    setPopupOpen(!isPopupOpen);
  };
  useEffect(() => {
    setValue("userId", state && state?.userId);
    setValue("firstName", state && state?.firstName);
    setValue("mobileNumber", state && state?.mobileNumber);
    setValue("emailId", state && state?.emailid);
    setValue("role", state && state?.role);
    setValue("status", state && state?.status);
    setValue("lastName", state && state?.lastName);
  }, []);


  const { mutate, isLoading, isError, isSuccess } = useMutation(
    (postdata) =>
      axios.put(
        `${process.env.REACT_APP_HOST}/users/${state&&state.id}`,
        postdata,
      ),
    {
      onSuccess: (val) => {
        console.log('data updated successfully..')
      },
      onError: (error) => {
        console.error('Mutation failed:', error)
      },
    },
  )

  const onSubmit = (data) => {
    let formData;
    if(state && state.id!=null)
    {
      formData={
        userId: data?.userId,
        firstName: data?.firstName,
        lastName: data?.lastName,
        mobileNumber: data?.mobileNumber,
        emailid: data?.emailId,
        role: data?.role,
        password: data?.password,
        confirmpassword: data?.confirmpassword,
        status: data?.status,
      }
    }
    mutate(formData);
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} className="px-3 py-4">
        <div className="dataEntryInputContainer py-2">
          <div className="data-entry-input-block">
            <label className="data-entry-label --add-user-label">
              {Strings.userid}
            </label>
            <div className="data-entry-input --add-user-input">
              <Controller
                control={control}
                name="userId"
                render={(field) => (
                  <InputField
                    dataEntryInputField="data-entry-input-field"
                    {...field}
                    type="text"
                    placeholder="3421631"
                  />
                )}
              />
            </div>
          </div>
        </div>
        <div className="dataEntryInputContainer py-2">
          <div className="data-entry-input-block">
            <label className="data-entry-label --add-user-label">
              {Strings.firstname}
            </label>
            <div className="data-entry-input --add-user-input">
              <Controller
                control={control}
                name="firstName"
                render={(field) => (
                  <InputField
                    dataEntryInputField="data-entry-input-field"
                    {...field}
                    type="text"
                    placeholder="PRASANTH"
                  />
                )}
              />
            </div>
          </div>
          <div className="data-entry-input-block">
            <label className="data-entry-label --add-user-label">
              {Strings.lastname}
            </label>
            <div className="data-entry-input --add-user-input">
              <Controller
                control={control}
                name="lastName"
                render={(field) => (
                  <InputField
                    dataEntryInputField="data-entry-input-field"
                    {...field}
                    type="text"
                    placeholder="A"
                  />
                )}
              />
            </div>
          </div>
        </div>
        <div className="dataEntryInputContainer py-2">
          <div className="data-entry-input-block">
            <label className="data-entry-label --add-user-label">
              {Strings.mobilenumber}
            </label>
            <div className="data-entry-input --add-user-input">
              <Controller
                control={control}
                name="mobileNumber"
                render={(field) => (
                  <InputField
                    dataEntryInputField="data-entry-input-field"
                    {...field}
                    type="number"
                    placeholder="7010489435"
                  />
                )}
              />
            </div>
          </div>
          <div className="data-entry-input-block">
            <label className="data-entry-label --add-user-label">
              {Strings.emailid}
            </label>
            <div className="data-entry-input --add-user-input">
              <Controller
                control={control}
                name="emailId"
                render={(field) => (
                  <InputField
                    dataEntryInputField="data-entry-input-field"
                    {...field}
                    type="email"
                    placeholder="prasanth@virtualworld.com"
                  />
                )}
              />
            </div>
          </div>
        </div>
        <div className="dataEntryInputContainer py-2">
          <div className="data-entry-input-block">
            <label className="data-entry-label --add-user-label">
              {Strings.password}
            </label>
            <div className="data-entry-input --add-user-input">
              <Controller
                control={control}
                name="password"
                render={(field) => (
                  <InputField
                    dataEntryInputField="data-entry-input-field"
                    {...field}
                    type="password"
                    placeholder="********"
                  />
                )}
              />
            </div>
          </div>
          <div className="data-entry-input-block">
            <label className="data-entry-label --add-user-label">ROLE</label>
            <div className="data-entry-input --add-user-input">
              <Controller
                name="role"
                control={control}
                defaultValue=""
                render={({ field }) => (
                  <select
                    {...field}
                    className="data-entry-input-field --select-option"
                  >
                    <option value="">SELECT ROLE</option>
                    <option value="admin">Admin</option>
                    <option value="superAdmin">Super Admin</option>
                  </select>
                )}
              />
            </div>
          </div>
        </div>
        <div className="dataEntryInputContainer py-2">
          <div className="data-entry-input-block">
            <label className="data-entry-label --add-user-label">
              {Strings.confirmpassword}
            </label>
            <div className="data-entry-input --add-user-input">
              <Controller
                control={control}
                name="confirmPassword"
                render={(field) => (
                  <InputField
                    dataEntryInputField="data-entry-input-field"
                    {...field}
                    type="password"
                    placeholder="********"
                  />
                )}
              />
            </div>
          </div>
          <div className="data-entry-input-block">
            <label className="data-entry-label --add-user-label">STATUS</label>
            <div className="data-entry-input --add-user-input">
              <Controller
                name="status"
                control={control}
                defaultValue=""
                render={({ field }) => (
                  <select
                    {...field}
                    className="data-entry-input-field --select-option"
                  >
                    <option value="">SELECT STATUS</option>
                    <option value="active">Active</option>
                    <option value="inactive">Inactive</option>
                  </select>
                )}
              />
            </div>
          </div>
        </div>
        <div className="addUserBtnContainer text-center py-3">
          <button className="add-user-submit-btn" onClick={togglePopup}>
            Submit
          </button>
        </div>
      </form>
      <PopUpModal isOpen={isPopupOpen} onClose={togglePopup}>
        <div className="img-block">
          <div style={{ width: "40%", height: "60%" }} className="mx-2 pt-2">
            <img src={logo} style={{ width: "100%", height: "100%" }} />
          </div>
        </div>
        <div className="d-flex flex-column align-items-center justify-content-center py-2">
          <h6 className="popup-content mb-3">
            User details has been changed successfully
          </h6>
          <button className="user-add-button mt-2 mb-2" onClick={()=>{
            navigate("/userManagement")
          }}>OK</button>
        </div>
      </PopUpModal>
    </>
  );
};

export default EditUserForm;
